import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-general-dash',
  templateUrl: './general-dash.component.html',
  styleUrls: ['./general-dash.component.scss']
})
export class GeneralDashComponent {

  isLoading = false;

  public salesData: any[] = [];
  public salesData1: any[] = [];
  public view: [number, number] = [700, 400];
  public showXAxis = true;
  public showYAxis = true;
  public gradient = false;
  public showLegend = true;
  public showXAxisLabel = true;
  public showYAxisLabel = true;
  public xAxisLabel = 'Date';
  public yAxisLabel = 'Sales (£)';
  public colorScheme = {
    domain: ['#2196f3', '#ff9800']
  };

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    //this.userName = localStorage.getItem('currentUserName');
    this.loadSalesData();
  }

  navigateTo(route: string): void {
    this.router.navigate(['/sales', route]);
  }

  private loadSalesData(): void {
    this.isLoading = true;
    this.authService.getGeneralSalesDash7Days({
      day: null,
      useDay: 0,  // Last 7 days
    }).subscribe({
      next: (response) => {
        if (response && response.totalSalesByWeekCreams && Array.isArray(response.totalSalesByWeekCreams)) {
          this.salesData = [
            {
              name: 'Creams',
              series: response.totalSalesByWeekCreams.map(item => ({
                name: item.dayOfWeek,
                value: item.totalSales
              }))
            },
          ];
        }
        if (response && response.totalSalesByWeekMH && Array.isArray(response.totalSalesByWeekMH)) {
          this.salesData1 = [
            {
              name: 'Mother Hubbards',
              series: response.totalSalesByWeekMH.map(item => ({
                name: item.dayOfWeek,
                value: item.totalSales
              }))
            }
          ];
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading sales data:', error);
        this.isLoading = false;
      }
    });
  }

  onSelect(event: any): void {
    console.log('Item clicked', event);
  }

  formatCurrency(value: number): string {
    return `£${value.toLocaleString()}`;
  }
}
